'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _connectHighlight = require('../connectors/connectHighlight.js');

var _connectHighlight2 = _interopRequireDefault(_connectHighlight);

var _Snippet = require('../components/Snippet.js');

var _Snippet2 = _interopRequireDefault(_Snippet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Renders an highlighted snippet attribute.
 * @name Snippet
 * @kind widget
 * @propType {string} attributeName - the location of the highlighted snippet attribute in the hit
 * @propType {object} hit - the hit object containing the highlighted snippet attribute
 * @example
 * import React from 'react';
 *
 * import {InstantSearch, connectHits, Snippet} from 'InstantSearch';
 *
 * const CustomHits = connectHits(hits => {
 *  return hits.map((hit) => <p><Snippet attributeName='description' hit={hit}/></p>);
 * });
 *
 * export default function App() {
 *  return (
 *    <InstantSearch
 *       appId="latency"
 *       apiKey="6be0576ff61c053d5f9a3225e2a90f76"
 *       indexName="ikea"
 *     >
 *       <CustomHits />
 *     </InstantSearch>
 *  );
 * }
 */
var _default = (0, _connectHighlight2.default)(_Snippet2.default);

exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_default, 'default', 'src/widgets/Snippet.js');
}();

;


//////////////////
// WEBPACK FOOTER
// /tmp/~/react-instantsearch/src/widgets/Snippet.js
// module id = 1199
// module chunks = 0